module.exports = __webpack_public_path__ + "static/media/loan.7adea8dd.svg";